import { render, staticRenderFns } from "./OnlineShopTeaser.vue?vue&type=template&id=123a0ae0&scoped=true&"
import script from "./OnlineShopTeaser.vue?vue&type=script&lang=js&"
export * from "./OnlineShopTeaser.vue?vue&type=script&lang=js&"
import style0 from "./OnlineShopTeaser.vue?vue&type=style&index=0&id=123a0ae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123a0ae0",
  null
  
)

export default component.exports